import styles from './PlatformIcon.module.css';
import { ReactComponent as InstagramIcon } from '../../assets/InstagramIcon.svg';
import { ReactComponent as TiktokIcon } from '../../assets/TiktokIcon.svg';
import cn from 'classnames';
import Skeleton from '../Skeleton/Skeleton';

type PlatformIconProps = {
    platform: string | null;
    containerClassName?: string;
    iconClassName?: string;
    loading?: boolean;
};

const PlatformIcon = ({ platform, containerClassName, iconClassName, loading }: PlatformIconProps) => {
    const getIcon = (platform: string | null) => {
        switch (platform) {
            case 'INSTAGRAM':
                return <InstagramIcon className={cn(styles.platformIcon, iconClassName)} />;
            case 'TIKTOK':
                return <TiktokIcon className={cn(styles.platformIcon, iconClassName)} />;
            default:
                return null;
        }
    };

    return (
        <div className={cn(styles.platformIconContainer, containerClassName)}>
            {loading ? (
                <Skeleton
                    circle
                    containerClassName={cn(styles.platformIconContainer, containerClassName, styles.skeletonContainer)}
                    className={styles.iconSkeleton}
                />
            ) : (
                getIcon(platform)
            )}
        </div>
    );
};

export default PlatformIcon;
